<template>
  <div class="materias-faltan-container">
    <CardIeaAppMain colorCard="transparent" title="" class="premium-wrapper">
      <v-col cols="12" class="pa-0">
        
        <!-- Hero Header -->
        <div class="hero-header glass-panel mb-4 py-3 px-6 mx-2 mx-sm-4 mt-4">
          <div class="d-flex align-center justify-space-between w-100 flex-wrap">
            <div class="d-flex align-center mb-2 mb-md-0">
              <v-btn icon dark color="primary" class="mr-4 glass-btn" @click="$router.go(-1)">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <div>
                <h1 class="text-h5 font-weight-bold primary-text mb-0">{{ title }}</h1>
                <p class="text-caption grey--text text--darken-1 mb-0 d-none d-sm-block">Listado de materias pendientes para completar tu plan de estudios</p>
                <p class="text-caption grey--text text--darken-1 mb-0 d-block d-sm-none">Materias Pendientes</p>
              </div>
            </div>
            <v-icon size="48" color="primary" class="opacity-30 d-none d-sm-block">mdi-book-remove-multiple-outline</v-icon>
          </div>
        </div>

        <v-card class="glass-card rounded-xl overflow-hidden mx-4 mb-4" elevation="10">
          <div class="pa-4 pa-sm-6 bg-light min-h-400">
            <div class="d-flex align-center mb-6">
              <v-icon color="warning" class="mr-2">mdi-alert-circle-outline</v-icon>
              <h2 class="text-h6 font-weight-bold primary-text mb-0">Materias Pendientes</h2>
            </div>
            
            <div v-if="materiaFaltantes.length === 0" class="d-flex flex-column align-center justify-center py-10">
               <v-icon size="64" color="success" class="mb-4">mdi-check-decagram-outline</v-icon>
               <h3 class="text-h6 success--text font-weight-medium text-center">¡Felicidades!</h3>
               <p class="grey--text text-center mt-2">No tienes materias pendientes por aprobar en este momento.</p>
            </div>

            <v-row v-else class="match-height">
              <v-col cols="12" sm="6" md="4" v-for="item in materiaFaltantes" :key="item.curso_id + '-' + item.id">
                <v-card class="rounded-xl border-light bg-white hover-card h-100 d-flex align-center" elevation="0">
                  <div class="pa-4 d-flex align-center w-100">
                    <div class="icon-wrapper warning-light-bg mr-4 flex-shrink-0">
                      <v-icon color="warning">mdi-book-alert-outline</v-icon>
                    </div>
                    <div>
                      <h3 class="text-subtitle-1 font-weight-bold primary-text mb-0 line-height-1">{{ item.materia }}</h3>
                      <div class="text-caption grey--text mt-1">
                        {{ item.estado === 'cursando' ? 'Cursando' : 'Pendiente de aprobación' }}<span v-if="multiCurso"> · {{ item.curso }}</span>
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>
<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
    name: 'Faltan',
    components: {
        CardIeaAppMain
    },
    computed: {
        user() {
            return this.$store.getters.user;
        }
    },
    data() {
        return {
            title: "Materias Que Me Faltan",
            materiaFaltantes: [],
            multiCurso: false
        }
    },
    methods: {
        // #404: antes cada curso pisaba la lista del anterior, las materias se agrupaban por los
        // primeros 16 caracteres del nombre y una materia aprobada seguía si el alumno volvía a
        // quedar inscripto. plan-estudio-alumno ya trae el estado calculado por materia.
        async MateriasFaltan() {
            await this.$API
                .get({ url: "plan-estudio-alumno", data: {} })
                .then(res => {
                    const cursos = Array.isArray(res) ? res : [];
                    this.multiCurso = cursos.length > 1;
                    this.materiaFaltantes = cursos.flatMap(c =>
                        c.materias
                            .filter(m => m.estado !== "aprobada")
                            .map(m => ({ ...m, curso_id: c.curso_id, curso: c.curso }))
                    );
                });
        },
    },
    mounted() {
        this.MateriasFaltan()
    },
}
</script>

<style scoped>
/* Glassmorphism Classes (Premium UI) */
.materias-faltan-container { background: transparent !important; min-height: calc(100vh - 120px); }
.glass-panel { background: rgba(255, 255, 255, 0.7) !important; backdrop-filter: blur(16px) !important; border: 1px solid rgba(255, 255, 255, 0.5) !important; box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.05) !important; border-radius: 20px; padding: 24px; }
.glass-card { background: rgba(255, 255, 255, 0.85) !important; backdrop-filter: blur(16px) !important; border: 1px solid rgba(255, 255, 255, 0.4) !important; }
.glass-btn { background: rgba(25, 118, 210, 0.1) !important; backdrop-filter: blur(4px) !important; box-shadow: none !important; transition: all 0.3s ease; }
.glass-btn:hover { background: rgba(25, 118, 210, 0.2) !important; transform: translateY(-2px); }
.bg-light { background-color: #f8fafc !important; }
.border-light { border: 1px solid rgba(0, 0, 0, 0.05) !important; }
.hover-card { transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1); border-left: 4px solid transparent; }
.hover-card:hover { transform: translateY(-4px); box-shadow: 0 12px 24px -8px rgba(0, 0, 0, 0.12) !important; border-left-color: var(--v-warning-base, #fb8c00); }
.primary-text { color: #1e293b; }
.opacity-30 { opacity: 0.3; }
.min-h-400 { min-height: 400px; }
.line-height-1 { line-height: 1.2; }
.w-100 { width: 100%; }

/* Custom elements */
.icon-wrapper { width: 48px; height: 48px; border-radius: 12px; display: flex; align-items: center; justify-content: center; }
.warning-light-bg { background-color: rgba(251, 140, 0, 0.08); }
</style>